export const BASE_URL= process.env.REACT_APP_BASEAPI_URL

// LoginAPI Endpoints
export const GetLoginById_url = "ReactLogin_api";
export const GetLoginByIdPassword_url = "User/validation";
export const ManualLogin_url = "User/login";
export const RedirectToUrl ="User/selectLgnRegMethod"
export const Register_url ="User/register"
export const ForgotPassword_url ="User/forgotPassword"
export const ResetPassword_url ="User/resetPassword"
export const validateResetPasswordToken_url = "User/validateResetPasswordToken"
export const CheckUserVehicle_url = "CheckUserVehicle_api"

export const UserLogout_url = "UserLogout_api"
// Token API Endpoint
export const GetRefreshToken_api = "Token_api";

// Weekly-Calendar API Endpoints
export const GetWeeklyCalendar_url = "MyWeeklyBookings_api";
export const ZoneList_url = "ZoneList_api";
export const MakeBooking_url = "MakeBooking_api";
export const CancelBooking_url = "CancelBooking_api";
export const MapGrid_api = "MapGrid_api";
export const MapCanvas_api = "MapCanvas_api";
export const GetParticipantsForMeeting_url = "MeetingRoom_api/GetParticipantsForMeeting";
export const RescheduleMeeting_url = "MeetingRoom_api/RescheduleMeeting";
export const MeetingRoomListAndInfo_url = "MeetingRoom_api/MeetingRoomListAndInfo";
export const CreateNewMeeting_url = "MeetingRoom_api/CreateNewMeeting";
export const ReportParkingViolation_url = "ReportParkingViolation_api"
export const GetAlternateParkingSpot_url = "GetAlternateParkingSpot_api";
export const CancelMeeting_url = "MeetingRoom_api/CancelMeeting";
export const DeclineMeeting_url = "MeetingRoom_api/DeclineMeeting";

// Notification API Endpoints
export const NotificationList_url = "NotificationList_api";
export const NotificationToggleStatus_url = "NotificationToggleStatus_api";
export const CheckInUser_url = "CheckInUser_api";
export const MarkAsReadNotification_url = "MarkAsReadNotification_api";
export const BookingConfirmation_url = "BookingConfirmation_api";
export const ScheduledBookingConfirmation_url = "ScheduledBookingConfirmation_api";
export const BookingStatus_url = "MakeBooking_api/BookingStatus";

// Post-Booking Question API Endpoints
export const PostBookingQuestion_url = "PostBookingQuestion_api";
export const PostBookingAnswer_url = "PostBookingAnswer_api";
export const MapBasedBooking_apiBookingStatus_url = "MapBasedBooking_api/BookingStatus"

// Home > My Bookings API Endpoints
export const HomeScreenBookings_url = "HomeScreenBookings_api";
export const SearchBookings_url = "SearchBookings_api";

// Home > My Inviatations API Endpoints
export const InvitationGuestBookings_url = "InvitationGuestBookings_api";
export const CheckInForGuestUser_url = "CheckInForGuestUser_api";
export const ReportParkingViolationForGuest_url = "ReportParkingViolationForGuest_api";
export const GetAlternateParkingSpotForGuest_url = "GetAlternateParkingSpotForGuest_api";

// Create New Booking API Endpoints
export const QuickBookingInfo_url = "QuickBookingInfo_api";
export const SpotAvailability_url = "SpotAvailability_api";
export const MapBasedBooking_url = "MapBasedBooking_api";

// Profile API Endpoints
export const Profile_url = "Profile_api";
